import React from 'react';
import PropTypes from 'prop-types';
import HeaderCollapseOption from './HeaderCollapseOption';
import Row from './Row';
import Card from './Card';
import CardSimpleHeader from './CardSimpleHeader';
import CardBody from './CardBody';

export default class CollapseCard extends React.Component {

    constructor(props) {
        super(props);

        this.state = { collapsed: props.collapsed };
    }

    renderHeaderOptions() {
        return (
            <HeaderCollapseOption
                collapsed={this.state.collapsed}
                onClick={() => this.setState({ collapsed: !this.state.collapsed })}
            />
        );
    }

    renderBody() {
        if ( this.state.collapsed ) {
            return null;
        }
        return (
            <CardBody>
                {this.props.children}
            </CardBody>
        );
    }

    render() {
        return (
            <Row clearfix>
                <Card loading={this.props.loading}>
                    <CardSimpleHeader
                        title={this.props.title.toUpperCase()}
                        options={this.renderHeaderOptions()}
                    />
                    {this.renderBody()}
                </Card>
            </Row>
        );
    }

}

CollapseCard.propTypes = {
    title: PropTypes.string.isRequired,
    collapsed: PropTypes.bool,
};

CollapseCard.defaultProps = {
    collapsed: true
};



// WEBPACK FOOTER //
// ./src/app/shared/components/CollapseCard.js